import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import DevDocsIndex from './Index.vue';
import DevDocsShow from './Show.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/dev-docs'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'dev_docs_list',
          meta: {
            permissions: ['administrator'],
          },
          component: DevDocsIndex,
        },
        {
          path: ':slug',
          name: 'dev_docs_show',
          meta: {
            permissions: ['administrator'],
          },
          component: DevDocsShow,
        },
      ],
    },
  ],
};
